var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "soegning-block-app" },
    [
      _vm.initial === false && _vm.performingNewSearch === false
        ? _c("search-output", {
            attrs: {
              "force-search-top":
                _vm.showSearchHeader && _vm.lodgings.length !== 0,
            },
            scopedSlots: _vm._u(
              [
                _vm.showSearchHeader && _vm.lodgings.length !== 0
                  ? {
                      key: "search-top",
                      fn: function () {
                        return [
                          _c(
                            "a",
                            {
                              staticClass: "go-left hidden-xs",
                              attrs: { href: _vm.mapPage + "?type=Search" },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.translations.search.loco_search_6) +
                                  " "
                              ),
                              _c("i", { staticClass: "cfa cfa-map" }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              ref: "search-sorter",
                              staticClass: "sorting go-right hidden-xs",
                              domProps: { value: _vm.search.searchOrder },
                              on: { change: _vm.updateSearchOrder },
                            },
                            [
                              _c("option", { attrs: { value: "default" } }, [
                                _vm._v(
                                  _vm._s(_vm.translations.search.loco_search_7)
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "option",
                                { attrs: { value: "esFromPrice" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.translations.search.loco_search_8
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "option",
                                { attrs: { value: "esFacility_179" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.translations.search.loco_search_9
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "option",
                                { attrs: { value: "esFacility_207" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.translations.search.loco_search_10
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "option",
                                { attrs: { value: "esFacility_9005" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.translations.search.loco_search_15
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "omraader" } }, [
                                _vm._v(
                                  _vm._s(_vm.translations.search.loco_search_12)
                                ),
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "vejnavn" } }, [
                                _vm._v(
                                  _vm._s(_vm.translations.search.loco_search_13)
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "printSmallBtn go-right hidden-xs",
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.triggerPrint.apply(null, arguments)
                                },
                              },
                            },
                            [_c("print-icon")],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
              ],
              null,
              true
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.fetchingPage === false &&
      (_vm.page < _vm.maxPages ||
        _vm.paginationType === "page" ||
        _vm.paginationType === "loadMore") &&
      _vm.performingNewSearch === false
        ? _c("pagination")
        : _vm.fetchingPage
        ? _c("spinner")
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }